import React from 'react';
import ReactDOMServer from 'react-dom/server';

import Calendar from 'app/components/shared/icons/calendar';

import { IDataTypeData } from '../../../PublicationContent';
import './styled';
import {
  DataTypeConveningIconContainer,
  DataTypeConveningPillText,
  DataTypeConveningPillWrapper,
} from './styled';

export const dataTypeConveningContentModifier = (
  node: HTMLDivElement,
  push: (location: any, state?: any) => void,
  setDataTypeData: React.Dispatch<React.SetStateAction<IDataTypeData>>
) => {
  node
    .querySelectorAll('[data-type="convenings"], [data-type="convening"]')
    .forEach((convening) => {
      const slug = convening.getAttribute('data-slug');
      const name = convening.textContent;
      const template = document.createElement('div');
      template.innerHTML = ReactDOMServer.renderToString(
        <DataTypeConveningPill name={name || ''} />
      );

      template.firstChild.addEventListener('click', () => {
        setDataTypeData({
          slug,
          type: 'convenings',
        });
        push(`/convening/${slug}`);
      });

      convening.replaceWith(template.firstChild);
    });
};

interface DataTypeConveningPillProps {
  name: string;
}

export const DataTypeConveningPill = ({ name }: DataTypeConveningPillProps) => {
  return (
    <DataTypeConveningPillWrapper>
      <DataTypeConveningIconContainer>
        <Calendar width={16} height={16} fill={'var(--color-data-community-foreground)'} />
      </DataTypeConveningIconContainer>
      <DataTypeConveningPillText>{name}</DataTypeConveningPillText>
    </DataTypeConveningPillWrapper>
  );
};
